import React, { useState } from "react";
import { ValidatedInput } from '../ValidatedInput.js/ValidatedInput';

import { alphanumericValidator, digitValidator, DIGIT_ONLY_REGEX, ALPHANUMERIC_REGEX } from '../../validators/InputValidator';


export default function RegisterCompanyInformation(props) {
    const { companyName, companyNumber, errors, setErrors, handleFieldUpdate } = props;

    const handleInputChange = (errorKey, inputValue, valueSetter, validator, regex) => {
        let validationError;
        if (validator) {
            validationError = validator(inputValue, regex)
        }

        valueSetter(errorKey, inputValue);

        if (validationError) {
            setErrors({ ...errors, [errorKey]: validationError });
        } else {
            setErrors(current => {
                // create copy of error state
                const copy = { ...current };
                // remove error key from object
                delete copy[errorKey];
                return copy;
            });
        }
    }

    return (
        <><div className="row">
            <div className="col">
                <ValidatedInput
                    label="Company Name*"
                    errorKey="companyName"
                    formName="companyInfo"
                    maxLength={256}
                    value={companyName}
                    valueSetter={handleFieldUpdate}
                    validator={alphanumericValidator}
                    regex={ALPHANUMERIC_REGEX}
                    onChange={handleInputChange}
                    errors={errors?.companyName}
                />
            </div>
            <div className="col">
                <ValidatedInput
                    label="Company Number*"
                    errorKey="companyNumber"
                    formName="companyInfo"
                    maxLength={10}
                    value={companyNumber}
                    valueSetter={handleFieldUpdate}
                    validator={digitValidator}
                    regex={DIGIT_ONLY_REGEX}
                    onChange={handleInputChange}
                    errors={errors?.companyNumber}
                />
            </div>
        </div>
        </>
    );
}